import { Injectable, Inject } from '@angular/core';
import { BaseDO } from './base.model';


export class VehicleDO extends BaseDO{
	public id: Number = null;

	public manufacturingDt: Number = null;

	public registrationDt: Date = null;

	public registrationNum: String = null;

	public chasisNum: String = null;

	public plateNumber: String = null;

	public zoneCd: String = null;

	public vehicleMakeCd: String = null;

	public vehicleModelCd: String = null;

	public vehicleVariant: String = null;

	public vehicleTypeCd: String = null;

	public vehicleColour: String = null;

	public usagePurpose: String = null;

	public bodyTypeCd: String = null;

	public engineNum: String = null;

	public engineCapacity: String = null;

	public fuelTypeCd: String = null;

	public seatingCapacity: Number = null;

	public transmissionType: String = null;

	public vehicleKey: String = null;

	public derivedVehicleMakeCd: String = null;

	public derivedVehicleModelCd: String = null;

	public derivedMakeModel: String = null;

	public derivedMakeVariantt: String = null;

	// public versionId: Number;

	// public guid: String;

	// public createdDt: Date;

	// public updatedDt: Date;

	// public createdUser: String;

	// public updatedUser: String;
}